/* @flow */

import moment from 'moment';
import { type State } from '../preact-app/types';

import {
    type IntervaloData,
} from '../utils/types';
import {
    type IntervaloDataState,
} from './intervalo-data-types';

type SetIntervaloAction = {
    type: 'intervalo-data/SET_INTERVALO',
    dataFinal: string,
    dataInicial: string,
};

type Actions = SetIntervaloAction;

// Action Types

const SET_INTERVALO = 'intervalo-data/SET_INTERVALO';

// Action creators

export const setIntervalo = ({
    dataInicial,
    dataFinal,
}: IntervaloData): SetIntervaloAction => ({
    type: SET_INTERVALO,
    dataInicial,
    dataFinal,
});

// Selectors

export const getIntervalo = (state: State): IntervaloData => state.intervaloData;
export const getLabel = (state: State): string => {
    const { dataFinal, dataInicial } = getIntervalo(state);

    if (dataInicial === dataFinal) {
        return moment(dataInicial, 'YYYY-MM-DD').format('L');
    }

    return [dataInicial, dataFinal]
        .map(data => moment(data, 'YYYY-MM-DD').format('L'))
        .join(' - ');
};

// Reducer

const initialState = {
    dataInicial: moment().format('Y-MM-DD'),
    dataFinal: moment().format('Y-MM-DD'),
};

const intervaloDataReducer = (
    state: IntervaloDataState = initialState,
    action: Actions,
): IntervaloDataState => {
    switch (action.type) {
    case SET_INTERVALO: {
        return {
            dataFinal: action.dataFinal,
            dataInicial: action.dataInicial,
        };
    }
    default:
        return state;
    }
};

export default intervaloDataReducer;
